// extracted by mini-css-extract-plugin
module.exports = {"modals":"modals_modals__3ISBf"};